// extracted by mini-css-extract-plugin
export default {"container":"p1-z"};